import { ProjectLogoSkeleton } from "components/terminal/ProjectInfo/ProjectLogoSkeleton"
import { projectLogoItem } from "./ProjectLogos.css"

export const ProjectLogosSkeleton = () => (
  <div className="flex gap-0 whitespace-nowrap leading-none items-center justify-start">
    <ProjectLogoSkeleton size={14} className={projectLogoItem} />
    <ProjectLogoSkeleton size={14} className={projectLogoItem} />
    <ProjectLogoSkeleton size={14} className={projectLogoItem} />
  </div>
)
